/**
 * Appends a query string built from the given fields to an endpoint path,
 * omitting undefined and empty-string values. Returns the path unchanged when
 * nothing remains.
 *
 * Output shape: `"/protected/partner/referrals?cursor=c1&limit=25"`
 */
export const appendQueryString = ({
  endpoint,
  query,
}: {
  endpoint: string;
  query: Record<string, string | number | undefined>;
}): string => {
  const searchParams = new URLSearchParams();
  Object.entries(query).forEach(([queryKey, queryValue]) => {
    if (queryValue !== undefined && queryValue !== "") {
      searchParams.set(queryKey, String(queryValue));
    }
  });
  const queryString = searchParams.toString();
  return queryString ? `${endpoint}?${queryString}` : endpoint;
};
